<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="[getSelectedDEV && 'dev-selected-component']">
    <v-timeline v-bind="schema.attributesTimeline" :class="['i4pro-timeline', schema.dateAlignTop && 'date-align-top']">
      <v-timeline-item v-for="(item, indexItem) in items" :key="indexItem" v-bind="schema.attributesTimelineItem" :color="schema.attributes.color">
        <span
          :class="[schema.attributes.opposite.type, schema.attributes.opposite.type == 'date-bg' && schema.attributes.opposite.color]"
          slot="opposite"
        >
          <v-icon :class="schema.attributes.opposite.color">calendar_today</v-icon>
          <span :class="schema.attributes.opposite.type == 'date-icon-bg' && `${schema.attributes.opposite.color}--text`">{{ item.date }}</span>
        </span>
        <div
          :class="['card-content', schema.attributes.typeCard]"
          :style="borderColor(indexItem, schema.attributes.color)"
          v-for="(card, indexCard) in item.children"
          :key="indexCard"
        >
          <v-card class="elevation-2 i4pro-timeline-card">
            <div v-for="(itemObj, indexObj) in listObjLine(card)" :key="indexObj">
              <div
                v-if="itemObj.key == 'title'"
                :class="['title', itemObj.class, borderTwoColor(itemObj.class)]"
                :style="titleBorderColor(schema.attributes.title.color)"
              >
                <span v-if="schema.attributes.title.display">{{ itemObj.title }}</span>
                {{ itemObj.value }}
              </div>

              <div v-else-if="itemObj.key == 'users'" :class="['line-default users', itemObj.class]">
                <span v-if="itemObj.isBg">
                  <v-chip
                    small
                    :color="itemObj.color ? itemObj.color : 'grey'"
                    :text-color="!schema.attributes.textOutlined && 'white'"
                    :outlined="schema.attributes.textOutlined"
                  >
                    {{ itemObj.title }}
                  </v-chip>
                </span>
                <span v-else>{{ itemObj.title }}</span>

                <ul :class="['listUsers', schema.attributes.users.type]">
                  <li v-for="(user, indexUser) in listUsers(itemObj.value, schema.attributes.users.type)" :key="indexUser">
                    <v-chip small v-bind="schema.attributesChips" :color="schema.attributesChips.color ? schema.attributesChips.color : 'grey'">
                      <v-avatar left>
                        <v-icon small>mdi-account-circle</v-icon>
                      </v-avatar>
                      {{ user }}
                    </v-chip>
                  </li>
                </ul>
              </div>

              <div v-else :class="[itemObj.class, 'line-default']">
                <span v-if="itemObj.isBg">
                  <v-chip
                    small
                    :color="itemObj.color ? itemObj.color : 'grey'"
                    :text-color="!schema.attributes.textOutlined && 'white'"
                    :outlined="schema.attributes.textOutlined"
                  >
                    {{ itemObj.title }}
                  </v-chip>
                </span>

                <span v-else :class="itemObj.color">{{ itemObj.title }}</span>

                <p>{{ itemObj.value }}</p>
              </div>
            </div>
          </v-card>
        </div>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
import moment from 'moment';
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';

export default {
  mixins: [abstractField, devComponentMixin],

  data() {
    return {
      items: []
    };
  },

  mounted() {
    this.createArray();
  },

  methods: {
    borderColor(index, color) {
      const numberEven = index % 2 == 0;

      if (color == 'primary') {
        return numberEven ? `border-color: var(--v-primary-base)` : `border-color: var(--v-primary-lighten1)`;
      } else {
        //ajustar cores dinamicas
        return `border-color: ${color};`;
      }
    },

    titleBorderColor(color) {
      let getColor = color ? color : this.schema.attributes.color;

      return getColor == 'primary' ? `border-color: var(--v-primary-base)` : `border-color: ${getColor};`;
    },

    borderTwoColor(color) {
      let borderTwo = color.indexOf('title-border-two') >= 0;

      return borderTwo && `border-two-left-${this.schema.attributes.color} border-two-right-${this.schema.attributes.title.color}`;
    },

    listObjLine(item) {
      let list = [];
      const card = Object.keys(item);

      this.schema.attributes.headers.forEach(headerItem => {
        card.forEach(objItem => {
          if (headerItem.value == objItem) {
            list.push({
              title: headerItem.text,
              value: item[headerItem.value],
              class: headerItem.class,
              color: headerItem.color,
              key: headerItem.value,
              isBg: headerItem.class.indexOf('text-bg') >= 0
            });
          }
        });
      });

      return list;
    },

    listUsers(users, type) {
      const userSplit = users.split(';');

      if (type == 'users-bg') {
        return userSplit;
      }
    },

    createArray() {
      let { items } = this.schema.attributes;

      if (items.length) {
        let list = {};
        for (let i = 0; i < items.length; i++) {
          const e = items[i];

          const newItem = e;
          if (!list[e.date]) {
            // ainda não tem nada nesta data, criar um novo
            list[e.date] = { date: moment(e.date).format('DD/MM/YYYY'), children: [newItem] };
          } else {
            // já existe registro para a data, adiciona no array children já existente
            list[e.date].children.push(newItem);
          }
        }

        this.items = Object.values(list);
      }
    }
  }
};
</script>
